import React from 'react';
import { useTranslation } from 'react-i18next';

// @ts-ignore
import sortAscIcon  from '../../../assets/images/datatable/sort-asc.svg';
// @ts-ignore
import sortDescIcon from '../../../assets/images/datatable/sort-desc.svg';
// @ts-ignore
import noSortIcon   from '../../../assets/images/datatable/no-sort.svg';

interface Props {
    label: string;
    fieldName?: string;
    sortable?: boolean;
    sortField?: string;
    sortOrder?: number;
    onSortToggle: (fieldName: string) => void;
}

export const PlainColumnHeader: React.FC<Props> = ({
    label,
    fieldName,
    sortable,
    sortField,
    sortOrder,
    onSortToggle,
}) => {
    const { t } = useTranslation();

    const isThisSorted = !!fieldName && sortField === fieldName;

    const sortIcon =
        isThisSorted && sortOrder === 1
            ? sortAscIcon
            : isThisSorted && sortOrder === -1
            ? sortDescIcon
            : noSortIcon;

    return (
        <div className="dt2-col-header">
            <div className="dt2-col-header__title-row">
                <span>{label}</span>

                {sortable && fieldName && (
                    <button
                        type="button"
                        className="dt2-sort-btn"
                        onClick={() => onSortToggle(fieldName)}
                        title={t('dataTable.sort', 'Sort')}
                    >
                        <img src={sortIcon} alt="" />
                    </button>
                )}
            </div>

            {/* Spacer row — keeps header height equal to filtered columns */}
            <div className="dt2-filter-row dt2-filter-row--empty" />
        </div>
    );
};